import Property from './Property';

export default Property;